export enum YesOrNoEnum {
  YES = 'yes',
  NO = 'no',
  NOT_SURE = '',
}

export enum QPSourceType {
  Vitrina = 'Vitrina',
  Client = 'Client',
  HubSpot = 'HubSpot',
  DELI = 'Deli'
}

export enum QPIngestionMethod {
  DELI = 'DELI',
  SelfService = 'SelfService',
}

export enum QPStatementType{
  'Public Quote' ='Public Quote',
  'Private Quote' ='Private Quote',
  'Public Policy'='Public Policy',
  'Derived Policy'='Derived Policy',
}